window.queue.afterMapsLoaded(() => {
  jQuery(document).ready(function($) {
    // Transfers map initialize
    if ($('#transfersMap').length > 0) {
      Functions.initTransfersMap();
    }
    // Prices map initialize
    if ($('#pricesMap').length > 0) {
      Functions.initPricesMap();
    }

    if ($('#geopoints')[0]) DirectionPageMap.init();

    // Google Draw on map initialize
    //
    var center = { lat: 55.755826, lng: 37.6173 };
    var zoomValue = 3;
    var $polygonInputObj = $('.polygon-input');
    var polygonInput = $polygonInputObj[0];

    if (polygonInput && polygonInput.input) {
      var tempArr = [];
      var sumArr = [];

      $.each($polygonInputObj, function(i, item) {
        var arr = Functions.parseInputValueToArr(item);
        tempArr.push(arr);
      });

      //console.log(tempArr);

      tempArr.forEach(function(item) {
        var tempArr = Functions.getCenter(item);
        sumArr.push(tempArr);
      });

      var averageCenter = Functions.getCenter(sumArr);
      center = { lat: averageCenter[0], lng: averageCenter[1] };

      //if($polygonInputObj.length > 1){
      //  zoomValue = 3;
      //}
    }

    if ($('#gMapDraw')[0]) {
      // Initialize map
      MapDrawing.createMap(center, zoomValue, $('#gMapDraw').data('inputContainer'));

      // Set DrawingManager to map
      MapDrawing.createDrawingManager();

      // Render polygons from backend
      MapDrawing.drawPolygonFromInputs('polygon-input');
    }

    if ($('#carrier-address').length > 0) {
      new RoutePoint('carrier-address', false, !$('#new-carrier-form')[0])
    }
  });
});

jQuery(document).ready(function ($) {
  var momentLocale = document.documentElement.lang
  if (momentLocale === 'zh') momentLocale += '-cn'
  moment.locale(momentLocale)
  moment.localeData('en')._longDateFormat.L = 'YYYY-MM-DD'; //Change en date format
  ['ar', 'bn'].forEach(locale => {
    if (moment.localeData(locale)) {
      moment.localeData(locale).postformat = x => x
    }
  })
  moment.defaultFormat = 'lll'

  var $tooltips = $('[data-toggle="tooltip"]');
  $tooltips.tooltip({ delay: 250 });

  $('[data-content-selector]').each(function () {
    var $this = $(this);
    var html = $($this.data('contentSelector')).html();
    if ($.trim(html).length === 0) return;
    $this.popover({
      html: true,
      content: html
    });
  });

  $('.transfer-offers-history').each(function () {
    var $this = $(this);
    var html = $($this.data('content')).html();
    if ($.trim(html).length === 0) return;
    $this.popover({
      html: true,
      content: html,
      container: 'body'
    });
  });

  // autosize for textarea
  autosize($('textarea'));

  // Hamburger responsive menu initialize
  //
  Functions.dropDown();
  //end

  // Prevent multiple form submitting
  $('form').on('submit', function (event) {
    if (this.submitting || event.isDefaultPrevented()) {
      event.preventDefault();
    } else {
      this.submitting = true;
    }
  });

  //setTimeout(function(){
  //  $('#jivo-iframe-container').remove();
  //}, 3000);

  // Intel Telephone Number init
  Functions.telephoneInput();

  Functions.passengerFlags();

  // DateTimePicker init
  Functions.dateTimePickerActivate();

  // Submit form for IE
  (function () {
    var $button = $('button[form]:submit');
    $button.on('click', function (e) {
      e.preventDefault();
      var value = $(this).attr('form');
      var $form = $('#' + value);
      var $message = $form.closest('.offers-list').find('.error-message');
      if ($form.length > 0) {
        if ($form.find('input[required]').length > 0) {
          var $input = $form.find('input[type="radio"]');
          if ($input.filter(':checked').length > 0) {
            $form.trigger('submit');
          } else {
            $message.addClass('active');
            setTimeout(function () {
              $message.removeClass('active');
            }, 2000);
          }
        } else {
          $form.trigger('submit');
        }
      }
    });
  })();

  //document.addEventListener('click', function(){transportTypesBlock.hide()});
  // ================================================ EVENTS ===================================================== //

  let $dropMenuItems = $('.top-nav__first-list .drop-menu__item li a');
  $dropMenuItems.on('click', function () {
    const ACTIVE_CLASS = 'drop-menu__item--active';
    $(this).closest('.drop-menu').find(`.${ACTIVE_CLASS}`).removeClass(ACTIVE_CLASS);
    $dropMenuItems
      .filter(`[data-value="${ $(this).data('value') }"]`)
      .parent()
      .addClass(ACTIVE_CLASS);
  });

  $('#menu-distance-units .drop-menu-item').on('click', function (event) {
    if ($('.gmap-table').length > 0) {
      event.preventDefault();
      Functions.setSetting('distance_unit', $(this).data('value'), function () {
        MapRoutes.changeMetrics();
      });
    }
  });

  $('.input-currency-select:not(.unbinded-currency-select)').on('change', function (event) {
    $('#menu-currency [data-value=\'' + $(this).val() + '\']').trigger('click');
  });

  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();
  });

  // Pagination and filtration throughout input radio

  var $filtering_inputs = $('*[form="filtering"]');
  if ($filtering_inputs.length > 0) {
    $filtering_inputs.filter(':not(.selectpicker)').change(function (event) {
      if ($(this).attr('name') !== 'page') {
        $('input:radio[name=page][value=1]').prop('checked', true);
      }
      $('form#filtering').trigger('submit');
    });

    let selectPrevValue = '';

    $filtering_inputs.filter('.selectpicker')
      .on('shown.bs.select', function () {
        selectPrevValue = $(this).val().join();
      })
      .on('hide.bs.select', function () {
        if ($(this).val().join() !== selectPrevValue) {
          $('form#filtering').trigger('submit');
        }
      });
  }

  $('select#carrier_payment_method').change(function () {
    $('#carrier_payment_method_form').submit();
  });

  // Scroll to section in mobile (entry pages)
  Functions.initMobileBanner();

  const $scrollSection = $('.scroll-to');
  const $mobileBannerHeight = $('#mobile-banner').outerHeight() || 0;
  if ($scrollSection.length > 0) {
    $('html,body').animate({
      scrollTop: $scrollSection.offset().top - $mobileBannerHeight
    }, 1000);
  }

  // Confirm buttons
  $('form[data-confirm]').on('submit', function () {
    return confirm($(this).data('confirm')) || (this.submitting = false);
  });

  // Block button
  $('button[data-block]').on('click', function () {
    return confirm($(this).data('block'));
  });

  // Transfer status confirmation
  $('#update_history_confirm').click(function (event) {
    var $status = $(this).closest('form').find('#status');
    if (!$status.val()) return;
    var confirmed = confirm($(this).data('confirm'));
    return confirmed;
  });

  // Selecting responsible Call-agent
  $('.responsible_select').on('change', function (event) {
    $(this).closest('form').trigger('submit');
  });

  Functions.holidaysManagement(
    $('[name="holiday[beginning]"]'),
    $('[name="holiday[ending]"]'),
    $('#holiday_time')
  );

  if (navigator.hasOwnProperty('webdriver')) {
    document.cookie = '_enquire_type=wd; path=/';
  }

  if ($('input.polygons-color').length > 0) {
    $('input.polygons-color').on('change', MapDrawing.setPolygonsColor);
  }

  $('.rating-container .icon-rate').on('click', Functions.setRating);

  $('form.multi-submit').on('submit', function () { this.submitting = false; });

  Functions.similarPageSlider('#similar-pages-slider');

  Functions.initPartnerWelcomePage();

  // clear input on button click
  $('.button-input-clear').each(function () {
    var $btn = $(this);
    var $inp = $btn.parent().find('input[type!="hidden"]');

    $inp.on('change input', function () {
      $btn.toggleClass('is-visible', !!this.value.length);
    }).change();
  });

  $('#show-unsuccessful-payments').on('click', function () {
    $('tr.unsuccessful-payment').toggleClass('d-table-row');
  });

  $('body').removeClass('is-page-loading');

  $('.chat-modal.open-now').modal()

  if ($('.selectpicker').length > 0) {
    $('.selectpicker').selectpicker()
  }

  $('#accept_cookie_btn').on('click', () => {
    let date = new Date(moment().add(2, 'year')).toUTCString()
    document.cookie = `cookieAccepted=true; expires=${date}; path=/`
    $('body').removeClass('show-cookie-notice').css('margin-bottom', 0);
    Functions.setRakutenInitValue();
  })

  const $modalVehicleManager = $('.modal-vehicle-image-manager')
  const $vehicleManager = $('.vehicle-image-manager')

  if ($modalVehicleManager.length) {
    $modalVehicleManager.on('show.bs.modal', Functions.modalUpdatePhotoStatus)
    $modalVehicleManager.find('[class*="btn-photo-"]').on(
      'click',
      { isModal: true, verifyAccess: $modalVehicleManager.data('verifyAccess') },
      Functions.updatePhotoStatus
    )
  }

  if ($vehicleManager.length) {
    $vehicleManager.ready(Functions.modalUpdatePhotoStatus)
    $vehicleManager.find('[class*="btn-photo-"]').on(
      'click',
      { isModal: false, verifyAccess: true },
      Functions.updatePhotoStatus
    )
  }

  // SOCKET.IO connection
  if (typeof window.SocketService !== 'undefined') {
    window.socketService = new window.SocketService(
      typeof io !== 'undefined' ? io : undefined
    );
  }

  //disable scroll on number inputs
  $('body').on('wheel', 'input[type=number]', function() { $(this).blur(); });

  Functions.initClipboard(document.querySelectorAll('.js-copy-content'));

  Functions.initDownloadVoucherLink();

  $('.js-regex-validate:not([data-regex-type=""])').on('input', function () {
    const expr = {
      special: /[^0-9A-Za-z,. ]/g,
      with_spaces: /[^0-9A-Za-z ]/g,
      regular: /[^0-9A-Za-z]/g,
      country_codes: /[^a-z,]/gi,
      full_names: /[^A-Za-z0-9 /?:().,'+\-&]/g
    };
    this.value = this.value.replace(expr[this.dataset.regexType], '');
  });
  Functions.airlineCardHolder('airline_card_surname');
  Functions.airlineCardHolder('airline_card_name', /[^A-Z\s]/);

  Functions.initPasswordChecker();

  const $selectCountry = $('#country-residence');
  const $licenseContractLink = $('#license-contract-link')

  if ($selectCountry.length && $licenseContractLink.length) {
    const link = $licenseContractLink.attr('href');
    const errorText = $licenseContractLink.data('error');

    $selectCountry.on('changed.bs.select loaded.bs.select', () => {
      const val = $selectCountry.val();
      const href = `${link}${val ? `?country_residence=${val}` : ''}`;

      $licenseContractLink.attr('href', href);
    });

    $licenseContractLink.click(e => {
      const country = $selectCountry.val();

      if (!country) {
        e.preventDefault();

        const popoverBlock = $selectCountry
          .closest('.bootstrap-select')
          .popover({
            container: 'body',
            content: errorText,
            trigger: 'manual',
            placement: 'top',
          })
          .popover('show');

        const $selectButton =
          $selectCountry.closest('.bootstrap-select').find('button');

        $selectButton.focus();

        $selectCountry.on('show.bs.select', () => popoverBlock.popover('hide'));
        $selectButton.on('blur', () => {
          setTimeout(() => {
            if (!$selectButton.is(':focus')) {
              popoverBlock.popover('hide');
            }
          }, 1000);
        });
      }
    });
  }

  Functions.convertDatesToLocalTz();

  $('body').on('focus', 'input[type="email"]:not([pattern])', function() {
    $(this)
      .attr('pattern', '[A-Za-z0-9._+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$')
      .on('input', () => this.setCustomValidity(''))
      .on('blur', () => {
        if (this.validity.patternMismatch) this.setCustomValidity(this.dataset.errorMessage);
      });
  });

  ShortTransferForm.init();

  let transferFormId = TransferForm.init()
  if (transferFormId !== 'new-transfer-form' && $('#gmap').length > 0) {
    let $gmapHidden = $('#gmap-hidden')
    if ($gmapHidden.length === 0) {
      MapRoutes.showRoute()
    } else {
      window.gmapCreated = false
      $gmapHidden.on('shown.bs.collapse', function () {
        if (!window.gmapCreated) {
          MapRoutes.showRoute()
          window.gmapCreated = true
          window.dispatchEvent(new CustomEvent('maps-loaded'))
        }
      })
    }
  }

  $('#widget-checkbox').change(event => {
    const isChecked = event.target.checked;
    $('#widget-form').toggle(isChecked);
    $('#widget-form select').prop({ required: isChecked });
  });
});
